import React from 'react'
import { FlatButton } from 'material-ui'

const customApptTypeSliderActions = (
  availableAppointmentTypeIds,
  currentApptTypes,
  destroyCustomMessageSetting,
  id,
  isTops,
  locationId,
  tempSliderName,
  toggleApptTypeDialog,
  updateCustomMessageSetting,
) => [
  <FlatButton
    label="delete"
    secondary
    onClick={() => destroyCustomMessageSetting({ id, location_id: locationId })}
  />,
  <FlatButton label="Cancel" primary onClick={toggleApptTypeDialog} />,
  <FlatButton
    label={isTops ? 'Ok' : 'Submit'}
    primary
    disabled={!availableAppointmentTypeIds.length}
    onClick={() =>
      updateCustomMessageSetting({
        appointment_type_ids: currentApptTypes,
        name: tempSliderName,
        id,
        location_id: locationId,
      })
    }
  />,
]
export default customApptTypeSliderActions



// WEBPACK FOOTER //
// ./src/components/Settings/CreateSlider/customApptTypeSliderActions.js